import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useRef } from "react";
import { useOnClickOutside } from "hooks/useClickOutside";
import { IChatParticipant } from "dto/Chat/IChat";

const Participant = ({ receiver }: { receiver: IChatParticipant }) => {
  return (
    <div className={styles.box}>
      <div className={styles.info}>
        <div className={styles.name}>{receiver.Label}</div>
      </div>
      <div className={styles.status}></div>
      {/* {addReceiverToCase && !added && (
        <div className={styles.addperson} onClick={() => addToCase(receiver)}>
          <AddPresonIcon title="Dodaj do listy adresowej"></AddPresonIcon>
        </div>
      )}
      <div className={styles.copy} onClick={() => copy(receiver)}>
        <CopyIcon title="Kopiuj"></CopyIcon>
      </div> */}
    </div>
  );
};

const ChatParticipantsViewModal: FC<Props> = ({ chat, toggle }) => {
  const ref = useRef(null);

  useOnClickOutside(ref, () => {
    toggle();
  });

  return (
    <div ref={ref} className={styles.modal}>
      <div className={styles.body}>
        {chat.Participants.map((r, index) => (
          <>
            <Participant key={index} receiver={r} />
            {chat.Participants.length - 1 > index && (
              <div className={styles.divinder}></div>
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export default ChatParticipantsViewModal;
